module.exports = __webpack_public_path__ + "static/media/popoverInfo.41dd88ab.png";